import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDefaultBuildingBlocks } from './llinkidGenericConfigProps';

const LLINKID_CORRELATION_ENDTERMS: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Concordantielijst',
    plural: 'Concordantielijst',
  },
  buildingBlocks: llinkidDefaultBuildingBlocks,
  edit: [],
  showPlaceholder: true,
  readOnlyNode: true,

  isNotDraggable: true,
  isNotDeletable: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default LLINKID_CORRELATION_ENDTERMS;
